import { render, staticRenderFns } from "./FolderWorkflowSendCosmoFormDialog.vue?vue&type=template&id=d1db3498&scoped=true"
import script from "./FolderWorkflowSendCosmoFormDialog.vue?vue&type=script&lang=js"
export * from "./FolderWorkflowSendCosmoFormDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderWorkflowSendCosmoFormDialog.vue?vue&type=style&index=0&id=d1db3498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1db3498",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VChip,VSkeletonLoader,VSwitch})
